// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ProgressBarTsx from "./ProgressBar.tsx";

let make = ProgressBarTsx.ProgressBar;

export {
  make,
}
/* make Not a pure module */
